<template>
  <div class="wrapper">
    <div class="swot-report-header">
      <i
        class="icon fas fa-arrow-circle-left"
        @click="$router.go(-1)"
        />
      <div class="swot-report-header-label">
        Análise SWOT
      </div>
    </div>
    <div class="swot-summary-board">
      <div class="swot-report-summary">
        <div class="swot-report-summary-text-container">
          <div class="swot-report-summary-header">
            Resumo de análise
          </div>
          <div class="swot-report-summary-text">
            O Resultado abaixo é baseado nos comentários realizados entre o período de
            <strong> {{ startDate }} a {{ endDate }}</strong>
            considerando uma amostra de comentários de
            <strong>{{ totalAnswers }} respostas</strong>
            utilizando Inteligência artificial para interpretação dos dados.
          </div>
        </div>
      </div>
      <div class="swot-report-summary-icon-container">
        <div style="display: flex;">
          <div class="swot-svg-container"
            style="padding-right: 6px;"
            @click="setBoardDisplayMode"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.3333 10.8325V16.6667C18.3333 16.8877 18.2455 17.0996 18.0892 17.2559C17.9329 17.4122 17.721 17.5 17.5 17.5H10.8333V10.8325H18.3333ZM9.16663 10.8325V17.5H2.49996C2.27895 17.5 2.06698 17.4122 1.9107 17.2559C1.75442 17.0996 1.66663 16.8877 1.66663 16.6667V10.8325H9.16663ZM9.16663 2.5V9.16583H1.66663V3.33333C1.66663 3.11232 1.75442 2.90036 1.9107 2.74408C2.06698 2.5878 2.27895 2.5 2.49996 2.5H9.16663ZM17.5 2.5C17.721 2.5 17.9329 2.5878 18.0892 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V9.16583H10.8333V2.5H17.5Z"
                :fill="selectedBoardColor"
              />
            </svg>
          </div>
          <div
            class="swot-svg-container"
            @click="setColumnDisplayMode"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.4998 17.5H7.49984V8.33333H12.4998V17.5ZM14.1665 17.5V8.33333H18.3332V16.6667C18.3332 16.8877 18.2454 17.0996 18.0891 17.2559C17.9328 17.4122 17.7209 17.5 17.4998 17.5H14.1665ZM5.83317 17.5H2.49984C2.27882 17.5 2.06686 17.4122 1.91058 17.2559C1.7543 17.0996 1.6665 16.8877 1.6665 16.6667V8.33333H5.83317V17.5ZM18.3332 6.66667H1.6665V3.33333C1.6665 3.11232 1.7543 2.90036 1.91058 2.74408C2.06686 2.5878 2.27882 2.5 2.49984 2.5H17.4998C17.7209 2.5 17.9328 2.5878 18.0891 2.74408C18.2454 2.90036 18.3332 3.11232 18.3332 3.33333V6.66667Z"
                :fill="selectedColumnColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="swot-board-column-container">
    <div
      v-if="displayMode === 'board'"
      class="swot-board"
    >
      <div class="swot-board-line">
        <div class="swot-two-columns">
          <div class="strength-box">
            <div class="strength-label">
              <div class="strength-label-text">
                Forças
              </div>
              <i class="fas fa-dumbbell"></i>
            </div>
            <div class="strength-line">
              <hr />
            </div>
            <div class="strength-text-description">
              <div class="swot-description-item"
                v-for="(item, indexStrength) in swots.strength"
                :key="indexStrength"
              >
                <div class="swot-description-item-number">
                  {{ indexStrength + 1 }}.
                </div>
                <div>
                  <strong>{{ item.title }} -</strong>
                  <label>
                    {{ item.summary }}
                  </label>
                  <br>
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
          <div class="weakness-box">
            <div class="weakness-label">
              <div class="weakness-label-text">
                Fraquezas
              </div>
              <i class="fas fa-unlink"></i>
            </div>
            <div class="weakness-line">
              <hr />
            </div>
            <div class="weakness-text-description">
              <div class="swot-description-item-right"
                v-for="(item, indexWeakness) in swots.weakness"
                :key="indexWeakness"
              >
                {{ indexWeakness + 1 }}.
                <strong>{{ item.title }} -</strong>
                <label>
                  {{ item.summary }}
                </label>
                <br>
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="swot-board-logo">
          <hr>
          <img
            src="../../../../../../assets/swot.png"
          >
        </div>
        <div class="swot-two-columns">
          <div class="opportunities-box">
            <div class="opportunities-label">
              <div class="opportunities-label-text">
                Oportunidades
              </div>
              <i class="fas fa-bullseye"></i>
            </div>
            <div class="opportunities-line">
              <hr />
            </div>
            <div class="opportunities-text-description">
              <div class="swot-description-item"
                v-for="(item, indexOpportunity) in swots.opportunity"
                :key="indexOpportunity"
              >
                <div class="swot-description-item-number">
                  {{ indexOpportunity + 1 }}.
                </div>
                <div>
                  <strong>{{ item.title }} -</strong>
                  <label>
                    {{ item.summary }}
                  </label>
                  <br>
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
          <div class="threat-box">
            <div class="threat-label">
              <div class="threat-label-text">
                Ameaças
              </div>
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="threat-line">
              <hr />
            </div>
            <div class="threat-text-description">
              <div class="swot-description-item-right"
                v-for="(item, indexThreat) in swots.threat"
                :key="indexThreat"
              >
                {{ indexThreat + 1 }}.
                <strong>{{ item.title }} -</strong>
                <label>
                  {{ item.summary }}
                </label>
                <br>
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="swot-column"
    >
      <div class="swot-column-card-container">
        <div class="swot-column-card">
          <div class="swot-column-card-header swot-column-card-header-strength">
            <div class="swot-column-card-header-icon">
              <i class="fas fa-dumbbell"></i>
            </div>
            <div class="swot-column-card-header-label">
              Forças
            </div>
          </div>
          <div class="swot-column-description-card">
            <div class="swot-column-description-item"
              v-for="(item, indexStrength) in swots.strength"
              :key="indexStrength"
            >
              <div class="swot-description-item-number">
                {{ indexStrength + 1 }}.
              </div>
              <div>
                <strong>{{ item.title }} -</strong>
                  {{ item.summary }}
                {{ item.description }}
              </div>
            </div>
          </div>
          <div class="swot-column-card-items">
          </div>
        </div>
        <div class="swot-column-card">
          <div class="swot-column-card-header swot-column-card-header-weakness">
            <div class="swot-column-card-header-icon">
              <i class="fas fa-unlink"></i>
            </div>
            <div class="swot-column-card-header-label">
              Fraquezas
            </div>
          </div>
          <div class="swot-column-description-card">
            <div class="swot-column-description-item"
              v-for="(item, indexWeakness) in swots.weakness"
              :key="indexWeakness"
            >
              <div class="swot-description-item-number">
                {{ indexWeakness + 1 }}.
              </div>
              <div>
                <strong>{{ item.title }} -</strong>
                  {{ item.summary }}
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="swot-column-card">
          <div class="swot-column-card-header swot-column-card-header-opportunity">
            <div class="swot-column-card-header-icon">
              <i class="fas fa-bullseye"></i>
            </div>
            <div class="swot-column-card-header-label">
              Oportunidades
            </div>
          </div>
          <div class="swot-column-description-card">
            <div class="swot-column-description-item"
              v-for="(item, indexOpportunity) in swots.opportunity"
              :key="indexOpportunity"
            >
              <div class="swot-description-item-number">
                {{ indexOpportunity + 1 }}.
              </div>
              <div>
                <strong>{{ item.title }} -</strong>
                  {{ item.summary }}
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="swot-column-card">
          <div class="swot-column-card-header swot-column-card-header-threat">
            <div class="swot-column-card-header-icon">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="swot-column-card-header-label">
              Ameaças
            </div>
          </div>          
          <div class="swot-column-description-card">
            <div class="swot-column-description-item"
              v-for="(item, indexThreat) in swots.threat"
              :key="indexThreat"
            >
              <div class="swot-description-item-number">
                {{ indexThreat + 1 }}.
              </div>
              <div>
                <strong>{{ item.title }} -</strong>
                  {{ item.summary }}
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swot-footer">
      *Lembre-se de que esta análise é simplificada e baseada no texto fornecido.
      Em uma situação real, uma análise SWOT seria muito mais detalhada e
      levaria em consideração várias outras variáveis.
    </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
// import api from '../../../../../../services/api';

export default {
  data: () => ({
    startDate: '01/01/2023',
    endDate: '27/09/2023',
    totalAnswers: 8527,
    displayMode: 'board',
    selectedColumnColor: '#BABABA',
    selectedBoardColor: '#5E5E5E',
    // swots: {},
    swots: {
      strength: [
        {
          title: 'Atendimento',
          summary: 'Quantidade de Comentários: 1344 - Sentimento: Positivo',
          description: 'O atendimento ao cliente é altamente valorizado e frequentemente mencionado de forma positiva nos feedbacks.',
        },
        {
          title: 'Rapidez',
          summary: 'Quantidade de Comentários: 532 - Sentimento: Positivo',
          description: 'A rapidez no atendimento ou na resolução de problemas é valorizada pelos clientes.',
        },
        {
          title: 'Qualidade Geral',
          summary: 'Quantidade de Comentários: 478 (bom) + 360 (excelente) - Sentimento: Positivo',
          description: 'A qualidade geral do serviço é frequentemente descrita como "bom" ou "excelente" pelos clientes.',
        },
        {
          title: 'Satisfação do Cliente',
          summary: 'Quantidade de Comentários: 355 (gostei) - Sentimento: Positivo',
          description: 'Muitos clientes expressam sua satisfação com o serviço, usando palavras como "gostei".',
        },
        {
          title: 'Atendentes',
          summary: 'Quantidade de Comentários: 242 (gostei) - Sentimento: Positivo',
          description: 'Os atendentes são frequentemente elogiados pelos clientes, indicando que a interação com a equipe é positiva. ',
        },
      ],
      weakness: [
        {
          title: 'Problemas Técnicos',
          summary: 'Quantidade de Comentários: 1110 - Sentimento: Negativo',
          description: 'A palavra "problema" é frequentemente mencionada, indicando que os clientes enfrentam desafios ou problemas técnicos ao usar o serviço.',
        },
        {
          title: 'Dificuldade na Resolução',
          summary: 'Quantidade de Comentários: 333 (resolver) + 247 (resolvido) - Sentimento: Negativo',
          description: 'Os clientes mencionam frequentemente dificuldades na resolução de problemas ou questões pendentes.',
        },
        {
          title: 'Atendimento',
          summary: 'Quantidade de Comentários: 265 - Sentimento: Negativo',
          description: 'Embora o atendimento seja mencionado como um ponto forte em comentários positivos, também aparece em comentários negativos, indicando áreas de melhoria.',
        },
        {
          title: 'Atendentes',
          summary: 'Quantidade de Comentários: 211 - Sentimento: Negativo',
          description: 'Os atendentes são mencionados em comentários negativos, sugerindo que, em alguns casos, a interação com a equipe não atendeu às expectativas do cliente.',
        },
        {
          title: 'Cartão',
          summary: 'Quantidade de Comentários: 182 - Sentimento: Negativo',
          description: 'Problemas ou desafios relacionados ao uso ou emissão de cartões são uma fonte de insatisfação para alguns clientes. ',
        },
      ],
      opportunity: [
        {
          title: 'Melhoria no Atendimento',
          summary: 'Quantidade de Comentários: 106 - Sentimento: Positivo',
          description: 'O atendimento é mencionado em sugestões de clientes, indicando espaço para aprimoramentos.',
        },
        {
          title: 'Melhoria no Aplicativo',
          summary: 'Quantidade de Comentários: 96 - Sentimento: Positivo',
          description: 'O aplicativo é outro aspecto frequentemente mencionado em sugestões, indicando que os clientes veem oportunidades para melhorias na interface ou funcionalidades.',
        },
        {
          title: 'Melhorias Gerais',
          summary: 'Quantidade de Comentários: 93 (melhorar) - Sentimento: Positivo',
          description: 'A palavra "melhorar" sugere que os clientes veem oportunidades de aprimoramento em diversas áreas do serviço.',
        },
        {
          title: 'Novas Funcionalidades',
          summary: 'Quantidade de Comentários: 91 (ter) - Sentimento: Positivo',
          description: 'A menção da palavra "ter" em sugestões pode indicar um desejo de novas funcionalidades ou características no serviço.',
        },
        {
          title: 'Ajustes no Serviço',
          summary: 'Quantidade de Comentários: 91 (deveria) - Sentimento: Positivo',
          description: 'A palavra "deveria" sugere que os clientes têm expectativas específicas sobre como o serviço poderia ser ajustado para melhor atender às suas necessidades.',
        },
      ],
      threat: [
        {
          title: 'Comparação com Concorrentes',
          summary: 'Quantidade de Comentários: 18 (RecargaPay) - Sentimento: Neutro',
          description: 'A menção de "RecargaPay" indica que alguns clientes comparam o serviço com concorrentes, o que pode representar uma ameaça se perceberem melhores vantagens em outras plataformas.',
        },
        {
          title: 'Limitações do Serviço',
          summary: 'Quantidade de Comentários: 15 (limite) - Sentimento: Neutro',
          description: 'A menção de "limite" sugere que alguns clientes podem encontrar restrições ao usar o serviço, o que pode levá-los a considerar alternativas.',
        },
        {
          title: 'Cartão',
          summary: 'Quantidade de Comentários: 23 - Sentimento: Neutro',
          description: 'Problemas ou desafios relacionados ao uso ou emissão de cartões são uma fonte de preocupação para alguns clientes e podem levá-los a considerar opções alternativas.',
        },
        {
          title: 'Aplicativo',
          summary: 'Quantidade de Comentários: 21 - Sentimento: Neutro',
          description: 'O aplicativo é mencionado em alguns comentários que sugerem comparações ou problemas, indicando que melhorias são necessárias para manter a competitividade.',
        },
        {
          title: 'Processo de Pagamento',
          summary: 'Quantidade de Comentários: 19 (fazer) - Sentimento: Neutro',
          description: 'O processo de pagamento ou recarga pode ser um ponto de fricção para alguns clientes, indicando uma área que pode ser aprimorada para evitar a perda de clientes para concorrentes.',
        },
      ],
    },
  }),

  computed: {
  },

  watch: {
  },

  methods: {
    setBoardDisplayMode() {
      this.selectedBoardColor = '#5E5E5E';
      this.selectedColumnColor = '#BABABA';
      this.displayMode = 'board';
    },
    setColumnDisplayMode() {
      this.selectedBoardColor = '#BABABA';
      this.selectedColumnColor = '#5E5E5E';
      this.displayMode = 'column';
    },
  },

  async mounted() {
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.swot-report-header {
  padding: 10px;
  display: flex;
  .swot-report-header-label {
    padding-left: 12px;
    color: #242424;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Segoe UI;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 109.091% */ 
  }
  .fa-arrow-circle-left {
    cursor: pointer;
  }
}
.swot-summary-board {
  display: flex;
  background: white;
  margin: 10px;
}
.swot-report-summary {
  margin: 10px;
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch; 
  border-radius: 4px;
  background: #FFF;
}
.swot-report-summary-text-container {
  display: flex;
  width: 952px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px; 
}
.swot-report-summary-header {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 109.091% */ 
}
.swot-report-summary.text {
  color: #333;
  text-align: justify;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; 
}
.swot-report-summary-icon-container {
  width: 100%;
  align-items: center;
  justify-content: end;
  display: flex;
  padding-right: 24px;
}
.swot-svg-container {
  cursor: pointer;
}
.icon {
  color: #3DB374;
  font-size: 20px;
}
.display-flex {
  display: flex;
}
.swot-board-column-container {
  margin: 10px;
  background: #FFF;
  padding-bottom: 16px;
}
.swot-column,
.swot-board {
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  border-radius: 4px;
}
.swot-board .swot-board-line {
  display: block;
  padding: 12px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  /* Default shadow */
  box-shadow: 0px 2px 6px 0px rgba(41, 70, 97, 0.20);
}
.swot-two-columns {
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}
hr {
  width: 102px;
  height: 6px;
  border: none;
  // position: absolute;
  margin: 8px 0px 20px 0px;
}
.weakness-box,
.opportunities-box,
.threat-box,
.strength-box {
  width: 50%;
}
.weakness-label,
.opportunities-label,
.threat-label,
.strength-label {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch; 
}
.weakness-line,
.threat-line,
.weakness-label,
.threat-label {
  flex-direction: row-reverse;
}
.weakness-label-text,
.opportunities-label-text,
.threat-label-text,
.strength-label-text {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 100% */ 
}
.fa-dumbbell {
  color: #236642;
}
.fa-unlink {
  color: #992215;
}
.fa-bullseye {
  color: #527BF2;
}
.fa-exclamation-triangle {
  color: #FCBE30;
}
.weakness-line,
.opportunities-line,
.threat-line,
.strength-line {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.opportunities-line,
.strength-line {
  flex-direction: column;
}
.weakness-line hr {
  background: #E53420;
}
.opportunities-line hr {
  background: #5299F2;
}
.threat-line hr {
  background: #FCBE30;
}
.strength-line hr {
  background: #4DE594;
}
.weakness-text-description,
.opportunities-text-description,
.threat-text-description,
.strength-text-description {
  align-self: stretch;
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  padding-top: 12px;
  strong {
    font-weight: 700;
  }
  label {
    color: #808080;
    margin-bottom: 0;
  }
  li {
    padding-bottom: 10px;
  }
}
.opportunities-text-description ol,
.strength-text-description ol {
  padding-left: 20px;
}
.threat-text-description,
.weakness-text-description {
  text-align: right;
}
.swot-description-item {
  display: flex;
  padding-bottom: 10px;
}
.swot-description-item-right {
  display: block;
  padding-bottom: 10px;
}
.swot-description-item-number {
  padding-right: 10px;
}
.swot-footer {
  align-self: stretch;
  color: #808080;
  text-align: center;
  font-family: Segoe UI;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.swot-column-card-container {
  width: 100%;
  display: flex;
  padding: 24px 14px;
}
.swot-column-card {
  display: block;
  width: 25%;
  margin: 0px 10px;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  /* Default shadow */
  box-shadow: 0px 2px 6px 0px rgba(41, 70, 97, 0.20);
}
.swot-column-card-header {
  width: 100%;
  display: flex;
  padding: 12px 0px;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  align-self: stretch; 
}
.swot-column-card-header-icon {
  font-size: 26px;
}
.swot-column-card-header-label {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 80% */
}
.swot-column-card-header-strength {
  background: #E2F4EA; 
}
.swot-column-card-header-weakness {
  background: #FFDDD9; 
}
.swot-column-card-header-opportunity {
  background: #EBF4FD; 
}
.swot-column-card-header-threat {
  background: #FFFCDC; 
}
.swot-column-description-card {
  display: block;
  padding: 12px 12px 24px 12px;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  font-size: 14px;
}
.swot-column-description-item {
  display: flex;
  padding-bottom: 6px;
}
.swot-board-logo {
  text-align: center;
  img {
    width: 65px;
    z-index: 1;
    position: relative;
  }
  hr {
    background: #D9D9D9;
    width: 100%;
    height: 1px;
    position: relative;
    top: 32px;
    margin: 0px;
    z-index: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/ai-swot-reports/swot-view/index.vue